import React from "react";
import DivShadow from "@components/layout/DivShadow";
import HStack from "@components/layout/HStack";
import TitleSetting from "./TitleSetting";
import Switch from "@components/ui/Switch";

type Props = {
  icon: React.ReactNode;
  label: string;
  isChecked: boolean;
  onAction: () => void;
};

const SwitchSetting = ({ icon, label, isChecked, onAction }: Props) => {
  return (
    <DivShadow className="rounded-[4px] p-3 bg-white dark:bg-darkBackgroundColor dark:shadow-none dark:border dark:border-darkMediumGray">
      <HStack justifyContent="between">
        <TitleSetting icon={icon} label={label} />
        <Switch isChecked={isChecked} onAction={onAction} />
      </HStack>
    </DivShadow>
  );
};

export default SwitchSetting;
